import { createSlice, PayloadAction } from "@reduxjs/toolkit";

// Product item type
export interface Vehicles {
  id: string;
  [key: string]: any;
}

// API response shape
interface VehiclesListResponse {
  vehicles: Vehicles[];
  total: number;
  page: number;
  totalPages: number;
}

// Slice state
interface VehiclesState {
  data: VehiclesListResponse | null;
  loading: boolean;
  error: string | null;
}

// Update payload
export interface VehiclesUpdatePayload {
  id: string;
  [key: string]: any;
}

const initialState: VehiclesState = {
  data: null,
  loading: false,
  error: null,
};

const changeRequestSlice = createSlice({
  name: "vehicles",
  initialState,
  reducers: {
    setChangeRequestList(
      state,
      action: PayloadAction<VehiclesListResponse>
    ) {
      state.data = action.payload;
      console.log( action.payload," action.payload action.payload action.payload_______")
      state.loading = false;
      state.error = null;
    },


    setLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },

    setError(state, action: PayloadAction<string | null>) {
      state.error = action.payload;
    },
  },
});

export const { setChangeRequestList, setLoading, setError } =
  changeRequestSlice.actions;

export default changeRequestSlice.reducer;
